module.exports = __webpack_public_path__ + "img/icon_yuntruck_tabbar.0027d34d.png";